import React from 'react';
import BaseTypography from 'components/typography/BaseTypography';
import { Box, Link } from '@mui/material';
import { ReactComponent as CrossIcon } from 'assets/svg/cross-icon.svg';
import { announcementBannerStyles } from 'layouts/pages/landing-page/components/announcement-bar/announcementBannerStyles';
import { getRedirectUrlWithParams } from '../../../../../utils/utils';

export function AnnouncementBanner({
	handleAnnouncementBarClick,
	isAnnouncementBarOpen,
	bannerData,
}) {
	return (
		isAnnouncementBarOpen &&
		bannerData?.status && (
			<Box id="announcement-banner-container" sx={{ ...announcementBannerStyles.mainContainer }}>
				<BaseTypography variant="b3_bold" sx={{ ...announcementBannerStyles.textStyle }}>
					{bannerData?.affogatoMessage}{' '}
					{bannerData.redirectEnabled && (
						<Link
							href={getRedirectUrlWithParams(`https://app.affogato.ai/${bannerData?.redirectPath}`)}
							style={{ textDecoration: 'underline', color: 'colors.dark6' }}
							target="_blank"
							rel="noopener noreferrer"
						>
							{bannerData?.redirectTitle}
						</Link>
					)}
				</BaseTypography>
				<CrossIcon
					style={{ ...announcementBannerStyles.iconStyle }}
					onClick={() => handleAnnouncementBarClick()}
				/>
			</Box>
		)
	);
}
